import { Container } from "@material-ui/core";
import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import urlImageDashboard from "../../assets/img/imagen-dashboard2.jpeg";

const Welcome = ({ user }) => {
  const [dataUser, setDataUser] = useState(null);

  useEffect(() => {
    let dataSend = { id_usuario: user?.id_usuario };
    const getUserData = async () => {
      await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //console.log(data);
          if (data.existe) {
            setDataUser(data.contenido[0]);
          } else {
            setDataUser(null);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
    getUserData();
  }, []);

  const showJustName = (wholeName) => {
    let name = "";
    let splitName = wholeName.split(" ");
    name = splitName[0];
    return name;
  };

  const getUserGender = (gender) => {
    let welcome = "Bienvenido!";
    if (gender === "Femenino") {
      welcome = "Bienvenida...!";
    }
    return welcome;
  };

  return (
    <Container maxWidth="md">
      <img src={urlImageDashboard} alt="Dashboard Logo" />
    </Container>
  );
};

export default Welcome;
